import React from 'react';
import { useSelector } from 'react-redux';
import { getLabels } from 'src/redux/app/selectors';

const factoryDefault = (val) => val;

const Label = ({ name, fallback, factory = factoryDefault, asHtml = false }) => {
  const labels = useSelector(getLabels);
  const value = factory(labels[name] || fallback || name);

  // eslint-disable-next-line react/no-danger
  return asHtml ? <span dangerouslySetInnerHTML={{ __html: value }} /> : value;
};

export default Label;
